/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
import React, { useEffect, useState, useContext } from 'react'

import {
  Box,
  CircularProgress,
  FormGroup,
  InputLabel,
  Grid,
  IconButton,
  Typography,
  Tooltip,
  TextField,
  List,
  ListItem,
  Divider,
  ListItemText,
  Menu,
  Button,
  MenuItem,
} from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import CloseIcon from '@material-ui/icons/Close'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import Axios from 'axios'
import MUIDataTable from 'mui-datatables'
import PropTypes from 'prop-types'
import { useParams } from 'react-router-dom'

import ModalManualGuide from './ModalManualGuide'
import ProductStatusChange from './ProductStatusChange/ProductStatusChangeDialog'
import useStyles from './viewOrder.styles'

import BackDrop from 'components/BackDrop'
import { PencilIcon } from 'components/icons/personalizedIcons'
import Tabs from 'components/Tabs'
import {
  ORDER_STATUS_ADMIN_LIST,
  STATUS_DICTIONARY,
  MANUAL_GUIDE_ELIGIBLE_STATUSES,
} from 'constants/ordersContants'
import { ADMIN, SUPER_ADMIN, ORDER_STATUS_ADMIN } from 'constants/rolesConst'
import { API_ORDERS, API_EDIT_ORDER } from 'constants/urls'
import useAuthContext from 'contextApi/AuthContext'
import convertToCurrencyCop from 'utils/convertToCurrencyCop'
import { downloadPdf, downloadZpl } from 'utils/functions'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      style={{ width: '100%' }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.arrayOf(PropTypes.object).isRequired,
  value: PropTypes.string.isRequired,
  index: PropTypes.string.isRequired,
}

export default function ViewOrder() {
  const { userLoggedin } = useContext(useAuthContext)
  const [order, setOrder] = useState([])
  const [statusChangeDialog, setStatusChangeDialog] = useState({
    isOpen: false,
    modificationData: null,
  })

  const [anchorEl, setAnchorEl] = useState(null)
  const [currentRowIndex, setCurrentRowIndex] = useState(null)
  const [selectedRows, setSelectedRows] = useState([])
  const [rowsSelectedIndices, setRowsSelectedIndices] = useState([])

  const [showinfoClient, setShowInfoClient] = useState({
    email: false,
    numberPhone: false,
  })
  const [tabs, setTabs] = useState([
    { value: 0, name: 'Información del cliente' },
    { value: 1, name: 'Información venta' },
    { value: 2, name: 'Información de facturación' },
    { value: 3, name: 'Información de envío' },
    { value: 4, name: 'Productos' },
  ])
  const [value, setValue] = useState(0)

  const [errorInfo, setErrorInfo] = useState({
    email: false,
    numberPhone: false,
  })
  const [messageError, setMessageError] = useState('')
  const [infoClient, setInfoClient] = useState({
    email: '',
    numberPhone: '',
  })
  const [typeAction, setTypeAction] = useState(0)
  const [isLoading, setIsLoading] = useState(true)
  const [manualGuideDialog, setManualGuideDialog] = useState({
    open: false,
    product: null,
  })
  const { idorder } = useParams()
  const classes = useStyles()

  const handleClick = (event, rowIndex) => {
    setAnchorEl(event.currentTarget)
    setCurrentRowIndex(rowIndex)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setCurrentRowIndex(null)
  }
  const downloadPrint = async (type, guide) => {
    setIsLoading(true)
    handleClose()
    await Axios.get(`${API_ORDERS}/PintLabel?printType=${type}&guideNumber=${guide}`)
      .then((response) => {
        if (response.status === 200) {
          setIsLoading(false)
          const downloadHandlers = {
            Carta: () => downloadPdf(response.data, `Carta - #${guide}`),
            Zebra: () => downloadPdf(response.data, `Zebra - #${guide}`),
            ZPL: () => downloadZpl(response.data, `ZPL - #${guide}`),
          }

          downloadHandlers[type]?.()
        }
      })
      .catch(() => {
        setIsLoading(false)
      })
  }

  const updateInfo = (info, cancelUpdate = false) => {
    if (info === 1) {
      setShowInfoClient({ numberPhone: false, email: cancelUpdate })
    } else if (info === 2) {
      setShowInfoClient({ email: false, numberPhone: cancelUpdate })
    }
  }

  const saveInfo = async () => {
    setIsLoading(true)
    const saveInfo = {
      id: idorder,
      phone: infoClient.numberPhone,
      email: infoClient.email,
    }
    await Axios.put(`${API_EDIT_ORDER}`, saveInfo)
      .then((response) => {
        if (response.status === 200) {
          setIsLoading(false)
          setMessageError('')
          setShowInfoClient({
            email: false,
            numberPhone: false,
          })
        }
      })
      .catch(() => {
        setIsLoading(false)
      })
  }
  const validationInfo = (infoData) => {
    if (infoData === 1) {
      if (infoClient.email === '') {
        setErrorInfo({ ...errorInfo, email: true })
        setMessageError('LLene el campo para continuar')
        return false
      }
      const validateEmail =
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
      const isEmail = validateEmail.test(infoClient.email)
      if (!isEmail) {
        setErrorInfo({ ...errorInfo, email: true })
        setMessageError('Escriba un correo valido')
        return false
      }
      setErrorInfo({ ...errorInfo, email: false })
      setMessageError('')
    } else {
      if (infoClient.numberPhone === '') {
        setErrorInfo({ ...errorInfo, numberPhone: true })
        setMessageError('LLene el campo para continuar')
        return false
      }
      const validatePhone = /^[0-9]{6,10}$/i
      const isPhone = validatePhone.test(infoClient.numberPhone)
      if (!isPhone) {
        setErrorInfo({ ...errorInfo, numberPhone: true })
        setMessageError('Escriba un número valido')
        return false
      }
      setErrorInfo({ ...errorInfo, numberPhone: false })
      setMessageError('')
    }
    saveInfo()
  }

  const getOrder = async () => {
    Axios.get(`${API_ORDERS}/${idorder}`)
      .then(function (result) {
        setInfoClient({
          email: result.data.billing_email,
          numberPhone: result.data.billing_phone,
        })
        setOrder(result.data)
        setIsLoading(false)
      })
      .catch(function (error) {
        setIsLoading(false)
      })
  }

  const showMenuItemsStatuses = () => {
    if (selectedRows.length === 0 || !productsTableData) {
      return (
        <TextField
          id="actions"
          select
          className={classes.actionsButton}
          disabled
          SelectProps={{
            native: true,
          }}
          variant="outlined"
        >
          <option value="0">Seleccione</option>
        </TextField>
      )
    }

    const firstSelectedIndex = selectedRows[0].dataIndex
    const firstSelectedStatus = productsTableData[firstSelectedIndex][7]
    const statusOptions = STATUS_DICTIONARY[firstSelectedStatus]?.options || []

    return (
      <TextField
        id="actions"
        select
        className={classes.actionsButton}
        value={typeAction}
        onChange={(e) => {
          e.preventDefault()
          setTypeAction(Number(e.target.value))
        }}
        SelectProps={{
          native: true,
        }}
        variant="outlined"
      >
        <option value="0">Seleccione</option>
        {statusOptions.map((option) => (
          <option
            key={option.id}
            value={option.id}
            style={{ fontFamily: 'Red Hat Display Regular' }}
          >
            {option.name}
          </option>
        ))}
      </TextField>
    )
  }

  const handleMenuActions = (selectedProductIds) => {
    if (typeAction === 0 || selectedRows.length === 0) {
      return
    }

    const firstSelectedIndex = selectedRows[0].dataIndex
    const currentStatus = productsTableData[firstSelectedIndex][7]

    const orderDetailIds = selectedProductIds
      .map((productId) => {
        const product = order.products.find((p) => p.id === productId)
        return product?.orderDetailId
      })
      .filter(Boolean)

    setStatusChangeDialog({
      isOpen: true,
      modificationData: {
        orderId: idorder,
        orderDetailIds,
        statusId: typeAction,
        currentStatus,
        productName:
          selectedProductIds.length > 1
            ? `${selectedProductIds.length} productos`
            : productsTableData[firstSelectedIndex][2],
      },
    })

    setTypeAction(0)
  }

  const hasAnyNewGuide = order?.products?.some((item) => item.newGuideNumber)

  const shipsTableData = order?.products?.map((item) => {
    return [
      item.id,
      item.hasReturn,
      item.name,
      item.SKU,
      item.initedPrice,
      item.value,
      item.quantity,
      item.status,
      item.transportCompany,
      item.guideNumber,
      item.checkTransport,
      item.newGuideNumber,
    ]
  })

  const productsTableData = order?.products?.map((item) => {
    return [
      item.id,
      item.hasReturn,
      item.name,
      item.SKU,
      item.initedPrice,
      item.value,
      item.quantity,
      item.status,
      item.orderDetailId,
    ]
  })

  useEffect(() => {
    if (userLoggedin.role === ADMIN) {
      setTabs([...tabs, { value: 5, name: 'Observaciones' }])
    }
    getOrder()
  }, [idorder, order.orderNumber])

  const columns = [
    {
      name: 'id',
      options: {
        display: false,
        download: false,
      },
    },
    {
      name: 'hasReturn',
      label: 'DEVOLUCIÓN',
      options: {
        display: 'none',
      },
    },
    {
      name: 'name',
      label: 'NOMBRE PRODUCTO',
      options: {
        customBodyRender: (name, tableMeta) => {
          return (
            <div>
              {name}
              {tableMeta.rowData[1] && <div className={classes.afterReturn} />}
            </div>
          )
        },
      },
    },
    {
      name: 'SKU',
      label: 'SKU',
    },
    {
      name: 'initedPrice',
      label: 'PRECIO',
      options: {
        display: value !== 3 || false,
        download: value !== 3 || false,
      },
    },
    {
      name: 'value',
      label: 'PRECIO PROMOCIÓN',
      options: {
        display: value !== 3 || false,
        download: value !== 3 || false,
      },
    },
    {
      name: 'quantity',
      label: 'CANTIDAD',
    },
    {
      name: 'status',
      label: 'ESTADO',
      options: {
        display: value !== 3 || false,
        download: value !== 3 || false,
      },
    },
    {
      name: 'transportCompany',
      label: 'TRANSPORTADORA',
      options: {
        display: value !== 4 || false,
        download: value !== 4 || false,
      },
    },
    {
      name: 'guideNumber',
      label: hasAnyNewGuide ? 'GUÍA ANTERIOR' : 'NÚMERO DE GUÍA',
      options: {
        display: value !== 4 || false,
        download: value !== 4 || false,
      },
    },
    {
      name: 'checkTransport',
      options: {
        display: false,
        download: false,
      },
    },
    {
      name: 'newGuideNumber',
      label: 'GUÍA ACTUAL',
      options: {
        display: hasAnyNewGuide && value !== 4,
        download: hasAnyNewGuide && value !== 4,
      },
    },
    {
      name: 'orderDetailId',
      options: {
        display: false,
        download: false,
      },
    },
    {
      name: '',
      label: '',
      options: {
        customBodyRender: (_, tableMeta) => {
          const orderId = idorder
          const orderDetailIds = [tableMeta.rowData[8]]
          const productStatus = tableMeta.rowData[7]

          if (
            value === 4 &&
            ORDER_STATUS_ADMIN_LIST.includes(productStatus) &&
            userLoggedin.scopes.includes(ORDER_STATUS_ADMIN)
          ) {
            return (
              <div>
                <Button
                  aria-controls="changeStatus"
                  onClick={(e) => handleClick(e, tableMeta.rowIndex)}
                >
                  <MoreVertIcon />
                </Button>
                <Menu
                  id="changeStatus"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl) && currentRowIndex === tableMeta.rowIndex}
                  onClose={handleClose}
                >
                  {STATUS_DICTIONARY[productStatus].options.map((option) => (
                    <MenuItem
                      key={option.id}
                      onClick={async () => {
                        setStatusChangeDialog({
                          isOpen: true,
                          modificationData: {
                            orderId,
                            orderDetailIds,
                            statusId: option.id,
                            currentStatus: productStatus,
                            productName: tableMeta.rowData[2],
                          },
                        })
                        handleClose()
                      }}
                    >
                      {option.name}
                    </MenuItem>
                  ))}
                </Menu>
              </div>
            )
          }

          const isManualGuideStatus =
            value === 3 &&
            MANUAL_GUIDE_ELIGIBLE_STATUSES.includes(productStatus) &&
            userLoggedin.role === SUPER_ADMIN
          const hasGuide = tableMeta.rowData[9] && tableMeta.rowData[10]

          return (
            <div>
              {hasGuide && (
                <>
                  <Button
                    aria-controls="downloadGuide"
                    aria-haspopup="true"
                    onClick={(e) => handleClick(e, tableMeta.rowIndex)}
                  >
                    <MoreVertIcon />
                  </Button>
                  <Menu
                    id="downloadGuide"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl) && currentRowIndex === tableMeta.rowIndex}
                    onClose={handleClose}
                  >
                    {isManualGuideStatus && (
                      <MenuItem
                        onClick={() => {
                          const product = order.products.find((p) => p.id === tableMeta.rowData[0])
                          setManualGuideDialog({ open: true, product })
                          handleClose()
                        }}
                      >
                        Agregar guía manual
                      </MenuItem>
                    )}
                    {hasGuide && (
                      <>
                        <MenuItem onClick={() => downloadPrint('Carta', tableMeta.rowData[9])}>
                          Descargar Carta
                        </MenuItem>
                        <MenuItem onClick={() => downloadPrint('Zebra', tableMeta.rowData[9])}>
                          Descargar Zebra
                        </MenuItem>
                        <MenuItem onClick={() => downloadPrint('ZPL', tableMeta.rowData[9])}>
                          Descargar ZPL
                        </MenuItem>
                      </>
                    )}
                  </Menu>
                </>
              )}
            </div>
          )
        },
      },
    },
  ]

  const options = {
    responsive: 'scroll',
    search: false,
    filterType: 'dropdown',
    selectableRows:
      value === 4 && userLoggedin.scopes.includes(ORDER_STATUS_ADMIN) ? 'multiple' : 'none',
    selectableRowsHeader: false,
    isRowSelectable: (dataIndex, selectedRows) => {
      if (value !== 4) return false

      const productStatus = productsTableData[dataIndex][7]
      if (!ORDER_STATUS_ADMIN_LIST.includes(productStatus)) return false

      if (selectedRows.data.length > 0) {
        const firstSelectedIndex = selectedRows.data[0].dataIndex
        const firstSelectedStatus = productsTableData[firstSelectedIndex][7]
        return productStatus === firstSelectedStatus
      }

      return true
    },
    setRowProps: (row, dataIndex) => {
      if (!productsTableData?.[dataIndex]) {
        return {}
      }

      if (value !== 4 || !userLoggedin.scopes.includes(ORDER_STATUS_ADMIN)) {
        return { className: classes.hideCheckbox }
      }

      const productStatus = productsTableData[dataIndex][7]
      if (!ORDER_STATUS_ADMIN_LIST.includes(productStatus)) {
        return { className: classes.hideCheckbox }
      }

      if (selectedRows.length > 0) {
        const firstSelectedIndex = selectedRows[0].dataIndex
        if (productsTableData[firstSelectedIndex]) {
          const firstSelectedStatus = productsTableData[firstSelectedIndex][7]
          if (productStatus !== firstSelectedStatus) {
            return { className: classes.hideCheckbox }
          }
        }
      }

      return {}
    },
    onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
      setSelectedRows(allRowsSelected)
      setRowsSelectedIndices(rowsSelected || [])
    },
    rowsSelected: rowsSelectedIndices,
    rowHover: true,
    filter: false,
    sort: false,
    print: false,
    serverSide: true,
    fixedSelectColumn: false,
    download: false,
    viewColumns: false,
    textLabels: {
      body: {
        noMatch: `${isLoading ? 'Cargando ...' : 'No hay registros'}`,
      },
      pagination: {
        next: 'Página siguiente',
        previous: 'Página anterior',
        rowsPerPage: 'Filas por página:',
        displayRows: 'de',
      },
      toolbar: {
        search: 'Buscar',
        downloadCsv: 'Descargar CSV',
      },
      selectedRows: {
        text: 'Fila(s) Seleccionada(s)',
      },
    },
    customToolbarSelect: (selectedRows, displayData) => {
      return (
        <Grid
          container
          className={classes.toolBarSelect}
          style={{ fontFamily: 'Red Hat Display Regular' }}
        >
          {showMenuItemsStatuses()}
          <Button
            color="primary"
            variant="contained"
            className={classes.btnApply}
            onClick={(e) => {
              e.preventDefault()
              const selectedData = selectedRows.data.map((row) => {
                return displayData[row.index].data[0]
              })
              handleMenuActions(selectedData)
            }}
          >
            Aplicar acción
          </Button>
        </Grid>
      )
    },
  }

  const changeTabs = (tabValue) => {
    setValue(tabValue)
    setSelectedRows([])
    setRowsSelectedIndices([])
  }

  return (
    <>
      <BackDrop open={isLoading} />
      <Typography variant="h6">
        Información de pedido:
        <span className={classes.numPedido}>{` Nº ${idorder}`}</span>
        {isLoading && (
          <CircularProgress size={24} style={{ marginLeft: 15, position: 'relative', top: 4 }} />
        )}
      </Typography>
      {order && (
        <Grid container justify="center" className={classes.divContent}>
          <Tabs value={value} tabs={tabs} onChange={changeTabs} />
          <TabPanel value={value} index={0}>
            <Grid className={classes.tabContent}>
              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid">Fecha y hora</InputLabel>
                <InputLabel htmlFor="datePaid" className={classes.input}>
                  {order.date_created}
                </InputLabel>
              </FormGroup>

              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid">Cliente</InputLabel>
                <InputLabel htmlFor="datePaid" className={classes.input}>
                  {`${order.billing_first_name} ${order.billing_last_name}`}
                </InputLabel>
              </FormGroup>

              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid">Cédula</InputLabel>
                <InputLabel htmlFor="datePaid" className={classes.input}>
                  {order.billing_identification}
                </InputLabel>
              </FormGroup>

              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid" error={!!errorInfo.numberPhone}>
                  Número de teléfono
                </InputLabel>
                {userLoggedin.role === ADMIN && showinfoClient.numberPhone && (
                  <FormGroup className={classes.formInput}>
                    <div className={classes.formField}>
                      <TextField
                        error={!!errorInfo.numberPhone}
                        fullWidth
                        id="numberPhone"
                        name="numberPhone"
                        helperText={<p className={classes.messageError}>{messageError}</p>}
                        value={infoClient.numberPhone || ''}
                        variant="outlined"
                        onChange={(event) => {
                          setInfoClient({ ...infoClient, numberPhone: event.target.value })
                        }}
                      />
                    </div>
                    {!isLoading ? (
                      <>
                        <Tooltip title="Guardar">
                          <IconButton
                            className={classes.btnEdit}
                            onClick={(event) => {
                              event.preventDefault()
                              validationInfo(2)
                            }}
                          >
                            <CheckIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Cancelar">
                          <IconButton
                            className={classes.btnDelete}
                            onClick={(event) => {
                              event.preventDefault()
                              setInfoClient({ ...infoClient, numberPhone: order.billing_phone })
                              setErrorInfo({ numberPhone: false, email: false })
                              setMessageError('')
                              updateInfo(2, false)
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </>
                    ) : (
                      <CircularProgress
                        size={24}
                        style={{ marginLeft: 15, position: 'relative', top: 4 }}
                      />
                    )}
                  </FormGroup>
                )}
                {!showinfoClient.numberPhone && (
                  <InputLabel htmlFor="datePaid" className={classes.input}>
                    {infoClient.numberPhone}
                    {userLoggedin.role === ADMIN && (
                      <Tooltip title="Editar">
                        <IconButton
                          className={classes.btnEdit}
                          onClick={(event) => {
                            event.preventDefault()
                            updateInfo(2, true)
                          }}
                        >
                          <PencilIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </InputLabel>
                )}
              </FormGroup>

              <FormGroup className={classes.formGroup}>
                <InputLabel
                  htmlFor="datePaid"
                  className={showinfoClient.email ? classes.marginEmail : null}
                  error={!!errorInfo.email}
                >
                  Correo electrónico
                </InputLabel>
                {userLoggedin.role === ADMIN && showinfoClient.email && (
                  <FormGroup className={classes.formInput}>
                    <div className={classes.formField}>
                      <TextField
                        error={!!errorInfo.email}
                        fullWidth
                        id="email"
                        name="email"
                        helperText={<p className={classes.messageError}>{messageError}</p>}
                        value={infoClient.email || ''}
                        variant="outlined"
                        onChange={(event) => {
                          setInfoClient({ ...infoClient, email: event.target.value })
                        }}
                      />
                    </div>
                    {!isLoading ? (
                      <>
                        <Tooltip title="Guardar">
                          <IconButton
                            className={classes.btnEdit}
                            onClick={(event) => {
                              event.preventDefault()
                              validationInfo(1)
                            }}
                          >
                            <CheckIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Cancelar">
                          <IconButton
                            className={classes.btnDelete}
                            onClick={(event) => {
                              event.preventDefault()
                              setInfoClient({ ...infoClient, email: order.billing_email })
                              setErrorInfo({ numberPhone: false, email: false })
                              setMessageError('')
                              updateInfo(1, false)
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </>
                    ) : (
                      <CircularProgress
                        size={24}
                        style={{ marginLeft: 15, position: 'relative', top: 4 }}
                      />
                    )}
                  </FormGroup>
                )}
                {!showinfoClient.email && (
                  <InputLabel htmlFor="datePaid" className={classes.input}>
                    {infoClient.email}
                    {userLoggedin.role === ADMIN && (
                      <Tooltip title="Editar">
                        <IconButton
                          className={classes.btnEdit}
                          onClick={(event) => {
                            event.preventDefault()
                            updateInfo(1, true)
                          }}
                        >
                          <PencilIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </InputLabel>
                )}
              </FormGroup>
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Grid className={classes.tabContent}>
              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid">Medio de pago</InputLabel>
                <InputLabel htmlFor="datePaid" className={classes.input}>
                  {order.payment_method_title}
                </InputLabel>
              </FormGroup>

              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="paymentId">Id de Pago</InputLabel>
                <InputLabel htmlFor="paymentId" className={classes.input}>
                  {order.pay_transaction_id}
                </InputLabel>
              </FormGroup>

              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid">Total con envío</InputLabel>
                <InputLabel htmlFor="datePaid" className={classes.input}>
                  {convertToCurrencyCop(Number(order.subtotal) + Number(order.shipping_cost))}
                </InputLabel>
              </FormGroup>

              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid">Total con IVA</InputLabel>
                <InputLabel htmlFor="datePaid" className={classes.input}>
                  {convertToCurrencyCop(Number(order.subtotal) + Number(order.tax))}
                </InputLabel>
              </FormGroup>

              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid">Costo de envío</InputLabel>
                <InputLabel htmlFor="datePaid" className={classes.input}>
                  {convertToCurrencyCop(Number(order.shipping_cost))}
                </InputLabel>
              </FormGroup>
              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid">Comprobante de envío</InputLabel>
                <InputLabel htmlFor="datePaid" className={classes.input}>
                  {order.shipping_tracking}
                </InputLabel>
              </FormGroup>

              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid">IVA</InputLabel>
                <InputLabel htmlFor="datePaid" className={classes.input}>
                  {convertToCurrencyCop(Number(order.tax))}
                </InputLabel>
              </FormGroup>
              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid">Valor asumido</InputLabel>
                <InputLabel htmlFor="datePaid" className={classes.input}>
                  {convertToCurrencyCop(Number(order.asumed || '0'))}
                </InputLabel>
              </FormGroup>
              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid">Subtotal</InputLabel>
                <InputLabel htmlFor="datePaid" className={classes.input}>
                  {convertToCurrencyCop(Number(order.subtotal || '0'))}
                </InputLabel>
              </FormGroup>
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Grid className={classes.tabContent}>
              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid">Cliente</InputLabel>
                <InputLabel htmlFor="datePaid" className={classes.input}>
                  {`${order.billing_first_name} ${order.billing_last_name}`}
                </InputLabel>
              </FormGroup>
              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid">Dirección 1</InputLabel>
                <InputLabel htmlFor="datePaid" className={classes.input}>
                  {order.billing_address_1}
                </InputLabel>
              </FormGroup>

              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid">Dirección 2</InputLabel>
                <InputLabel htmlFor="datePaid" className={classes.input}>
                  {order.billing_address_2}
                </InputLabel>
              </FormGroup>
              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid">Ciudad</InputLabel>
                <InputLabel htmlFor="datePaid" className={classes.input}>
                  {order.billing_city}
                </InputLabel>
              </FormGroup>
              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid">Departamento</InputLabel>
                <InputLabel htmlFor="datePaid" className={classes.input}>
                  {order.billing_state}
                </InputLabel>
              </FormGroup>
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={3}>
            <Grid className={classes.tabContent}>
              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid">Cliente</InputLabel>
                <InputLabel htmlFor="datePaid" className={classes.input}>
                  {`${order.shipping_first_name} ${order.shipping_last_name}`}
                </InputLabel>
              </FormGroup>
              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid">Dirección 1</InputLabel>
                <InputLabel htmlFor="datePaid" className={classes.input}>
                  {order.shipping_address_1}
                </InputLabel>
              </FormGroup>
              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid">Dirección 2</InputLabel>
                <InputLabel htmlFor="datePaid" className={classes.input}>
                  {order.shipping_address_2}
                </InputLabel>
              </FormGroup>
              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid">Ciudad</InputLabel>
                <InputLabel htmlFor="datePaid" className={classes.input}>
                  {order.shipping_city}
                </InputLabel>
              </FormGroup>
              <FormGroup className={classes.formGroup}>
                <InputLabel htmlFor="datePaid">Departamento</InputLabel>
                <InputLabel htmlFor="datePaid" className={classes.input}>
                  {order.shipping_state}
                </InputLabel>
              </FormGroup>
            </Grid>
            <FormGroup className={classes.formGroup}>
              <InputLabel htmlFor="datePaid">Productos enviados</InputLabel>
              {order?.products !== undefined && (
                <MUIDataTable data={shipsTableData} columns={columns} options={options} />
              )}
            </FormGroup>
          </TabPanel>
          <TabPanel value={value} index={4}>
            {order && order.products && (
              <MUIDataTable data={productsTableData} columns={columns} options={options} />
            )}
          </TabPanel>

          {/* observaciones */}
          <TabPanel value={value} index={5}>
            {order && order.observations ? (
              <List component="nav" aria-label="observations">
                {order.observations.map((observation) => {
                  return (
                    <>
                      <ListItem>
                        <ListItemText primary={observation} />
                      </ListItem>
                      <Divider />
                    </>
                  )
                })}
              </List>
            ) : (
              <Grid container justifyContent="center">
                <Typography> No hay observaciones </Typography>
              </Grid>
            )}
          </TabPanel>
        </Grid>
      )}
      <ProductStatusChange
        open={statusChangeDialog.isOpen}
        modificationData={statusChangeDialog.modificationData}
        onClose={() => setStatusChangeDialog({ isOpen: false, modificationData: null })}
        onConfirm={getOrder}
      />
      {manualGuideDialog.open && manualGuideDialog.product && (
        <ModalManualGuide
          open={manualGuideDialog.open}
          onClose={() => setManualGuideDialog({ open: false, product: null })}
          product={manualGuideDialog.product}
          orderId={idorder}
          productCount={order?.products?.length ?? 0}
          onSuccess={getOrder}
        />
      )}
    </>
  )
}
